var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "580px",
    height: "348px",
    viewBox: "0 0 580 348",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Base/Import/Completed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Element/Contacts/Failed",
    transform: "translate(2.000000, 2.000000)",
    fill: "#FFFFFF",
    stroke: "#F7B500",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base/Import/Failed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 L566,0 C571.522847,-1.01453063e-15 576,4.4771525 576,10 L576,334 C576,339.522847 571.522847,344 566,344 L10,344 C4.4771525,344 6.76353751e-16,339.522847 0,334 L0,10 C-6.76353751e-16,4.4771525 4.4771525,1.01453063e-15 10,0 Z",
    id: "Base/Import/Default"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrange);
export default __webpack_public_path__ + "static/media/Orange.19c24a28cb3be97dcec21977992ea217.svg";
export { ForwardRef as ReactComponent };